// PACKAGES
import React, { useState, useRef, useEffect } from "react";
import Axios from "axios";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import { Dropdown } from "semantic-ui-react";

// MATERIAL UI
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

// COMPONENTS
import RoomCheckBox from "../product-card/product-information-dialog/RoomCheckBox";
import AddNSuploader from "./AddNSuploader";
import ReactLoader from "react-loader-spinner";
import Translated from "../../components/Translated/Translated";

// FILES
import * as actionTypes from "../../store/actions";
import "./AddNonStockDialog.scss";
import translator from "../../utils/translator";
import api from "../../utils/api";
import { displayError, displaySuccess } from "../../utils/toastHelper";

function AddNonStockDialog(props) {
	const [open, setOpen] = useState(false);
	const [title, setTitle] = useState("");
	const [model, setModel] = useState("");
	const [supplier, setSupplier] = useState("");
	const [validSupplier, setValidSupplier] = useState(null); // null = untouched, true = valid, false = invalid
	const [supplierOptions, setSupplierOptions] = useState([]);
    const [supplierLoading, setSupplierLoading] = useState(false);
	const [itemGroup, setItemGroup] = useState("");
	const [validItemGroup, setValidItemGroup] = useState(null); // null = untouched, true = valid, false = invalid
	const [itemGroupOptions, setItemGroupOptions] = useState([]);
    const [itemGroupLoading, setItemGroupLoading] = useState(false);
    const userModifiedItemGroupRef = useRef(false);

    const supplierTimeout = useRef(null);
    const itemGroupTimeout = useRef(null);

	useEffect(() => {
		return () => {
			if (supplierTimeout.current) clearTimeout(supplierTimeout.current);
			if (itemGroupTimeout.current) clearTimeout(itemGroupTimeout.current);
		};
	}, []);
	const [itemCost, setItemCost] = useState("");
	const [purchasePrice, setPurchasePrice] = useState("");
	const [price, setPrice] = useState("");
	const [
		requiredProductInformationToUpdateItsQuantityFinalized,
		setRequiredProductInformationToUpdateItsQuantityFinalized
	] = useState([]); // Arr of objs - now with only properties roomName & quantity
	const [image_file, set_image_file] = useState({}); // not used anymore
	const [spec_file, set_spec_file] = useState({}); // not used anymore

	const [uploads, set_uploads] = useState({image: "", spec: ""});
	
	function update_uploads(field, file) {
		set_uploads({ ...uploads, [field]: file });
	}

	const toast_config = {
        position: "bottom-center",
        autoClose: false,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
    };

	async function uploadFiles(field, product_id) {

		let loadingToast = toast.info(translator("Misc", "uploading_label"), toast_config);

        let response = await Axios.post(
            props.APIUrl + "/uploader/upload-ns-file", 
            { 
                project_id: props.projectId,
                product_id: product_id,
                field: "non_stock_" + field,
				file: uploads[field],
				// --- PHP params ---
				trendId: localStorage.getItem("trendId"),
				token: localStorage.getItem("token"),
				language: props.selected_language
            }
        );
        if(response.hasOwnProperty("success")) {
            toast.dismiss(loadingToast);
		    toast.success(translator("Misc", "update_success"), { ...toast_config, autoClose: 2000 });
        } else {
            toast.dismiss(loadingToast);
		    toast.error(response.error, toast_config);
        }
	};

		// race-condition guard
		const itemGroupRequestId = useRef(0);
		const fetchItemGroupSuggestions = async (searchQuery, supplierNo, currentValueForInjection) => {
			if (!supplierNo) { 
				console.log('[AddNonStockDialog] fetchItemGroupSuggestions no supplier -> clear');
				setItemGroupOptions([]); 
				return; 
			}
			const reqId = ++itemGroupRequestId.current;
			console.log('[AddNonStockDialog] fetchItemGroupSuggestions START', { reqId, searchQuery, supplierNo, currentValueForInjection, stateItemGroup: itemGroup });
			setItemGroupLoading(true);
			try {
				const response = await api.post('/products/search-item-groups', { supplierNo, q: searchQuery || '' });
				const list = response?.listOfItemGroups || response || [];
				let options = list.map(item => ({
					key: String(item.itgr),
					text: item.description ? `${item.itgr} — ${item.description}` : String(item.itgr),
					value: String(item.itgr),
				}));
				const currentVal = (currentValueForInjection || itemGroup || '').trim();
				if (currentVal && !options.some(o => o.value === currentVal)) {
					console.log('[AddNonStockDialog] Inject current itemGroup', currentVal);
					options = [{ key: currentVal, text: currentVal, value: currentVal }, ...options];
				}
				if (reqId !== itemGroupRequestId.current) {
					console.log('[AddNonStockDialog] STALE response ignored', { reqId });
					return;
				}
				setItemGroupOptions(options);
				console.log('[AddNonStockDialog] fetchItemGroupSuggestions DONE', { reqId, optionCount: options.length });
				if ((!searchQuery || searchQuery === '') && list.length === 1 && !userModifiedItemGroupRef.current && !itemGroup) {
					console.log('[AddNonStockDialog] Auto-select sole backend option (initial only)', list[0].itgr);
					setItemGroup(String(list[0].itgr));
					setValidItemGroup(true);
				} else if ((!searchQuery || searchQuery === '') && list.length === 1 && userModifiedItemGroupRef.current) {
					console.log('[AddNonStockDialog] Suppressed auto-select because user modified itemGroup');
				}
			} catch (e) {
				if (reqId !== itemGroupRequestId.current) return; // stale
				console.error('[AddNonStockDialog] fetchItemGroupSuggestions ERROR', e);
				setItemGroupOptions(opts => {
					const currentVal = (currentValueForInjection || itemGroup || '').trim();
					if (currentVal && !opts.some(o => o.value === currentVal)) {
						return [{ key: currentVal, text: currentVal, value: currentVal }];
					}
					return [];
				});
			} finally {
				if (reqId === itemGroupRequestId.current) setItemGroupLoading(false);
			}
		};

    const fetchSupplierSuggestions = async (searchQuery) => {
        if (!searchQuery) return;
        setSupplierLoading(true);
        try {
            const response = await api.post('/products/search-supplier', { query: searchQuery });
            const payload = response?.data ?? response;
            const list = payload?.listOfSuppliers ?? [];

            const options = list.map(item => ({
                key: item.SUNO,
                text: `${item.SUNM} (${item.SUNO})`,
                value: String(item.SUNO),
            }));

            setSupplierOptions(options);
        } catch (error) {
            console.error("Failed to fetch supplier suggestions", error);
            setSupplierOptions([]);
        } finally {
            setSupplierLoading(false);
        }
    };

	const [dialog, setDialog] = useState(null);

	async function handleClickOpen() {
		setOpen(true);
		set_uploads({image: "", spec: ""});
	}

	function handleClose() {
		setOpen(false);
	}

	async function saveNewNonStock() {
		setDialog(
			<Dialog open={true} aria-labelledby="form-dialog-title">
				<DialogTitle id="form-dialog-title set-price-dialog-header">
					Loading...{" "}
				</DialogTitle>
				<DialogContent
					style={{
						paddingRight: "10em"
					}}
				>
					<ReactLoader
						style={{
							marginLeft: "8em"
						}}
						type="Oval"
						color="#00BFFF"
						height={50}
						width={50}
					/>
				</DialogContent>
			</Dialog>
		);

		if (model && title && price && itemCost && purchasePrice) {
			if(title.length > 48) {
				setDialog(null);
				return toast.error(
					"Please ensure the description is 48 characters or less.",
					{
						position: "bottom-center",
						autoClose: 5000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true
					}
				);
			}

			if (validSupplier !== true) {
				const isValid = await api.post(
					"/products/validate-supplier",
					{ supplier }
				);
				if (!isValid) {
					displayError(new Error("Invalid Supplier"));
					setDialog(null);
					return;
				} else {
					setValidSupplier(true);
				}
			}

			if (validItemGroup !== true) {
				const isValid = await api.post(
					"/products/validate-item-group",
					{ itemGroup }
				);
				if (!isValid) {
					displayError(new Error("Invalid Item Group"));
					setDialog(null);
					return;
				} else {
					setValidItemGroup(true);
				}
			}

			let roomProductQuantities = requiredProductInformationToUpdateItsQuantityFinalized.map(roomQuantity => {
				return {
					quantity: roomQuantity.quantity,
					roomName: roomQuantity.roomName,
					SX_Prod_Id: null,
					accountId: props.accountId,
					non_stock_model: model,
					non_stock_title: title,
					non_stock_price: price,
					non_stock_supplier: supplier,
					non_stock_item_group: itemGroup,
					non_stock_item_cost: itemCost,
					non_stock_purchase_price: purchasePrice
				}
			});

			// Authentication
			const instance = Axios.create({
				headers: {
					Authorization: "Bearer " + localStorage.getItem("token")
				}
			});

			let increaseProductQuantityForThisProjectAPIUrl =
				props.APIUrl + "/products/project-product-quantity";

			let data = {
				roomNamesAndProductQuantityAndTrendProductId: roomProductQuantities,
				projectId: props.projectId,
				accountId: props.accountId,
				trendUserAuthenticationToken: localStorage.getItem("token"),
				// add the non stock values
				non_stock_title: title,
				non_stock_price: price,
				non_stock_model: model,
				non_stock_supplier: supplier,
				non_stock_item_group: itemGroup,
				non_stock_item_cost: itemCost,
				non_stock_purchase_price: purchasePrice,
				non_stock_image_file_name: image_file.name === undefined ? null : image_file.name,
				non_stock_spec_file_name: spec_file.name === undefined ? null : spec_file.name,
				language: props.selected_language
			};

			let increaseProductQuantityForThisProjectAPIResponse = await instance.post(
				increaseProductQuantityForThisProjectAPIUrl,
				data
			);
			// --- Clearly we created a non stock product since this is in the saveNonStock function. But the route handler manages normal products AND non stock products. that is why the "did_we_create_non_stock_product" property exists. I feel like I should have created another route handler function that way it can be more managable in the future. But Mark was rushing me way back when I created it so it's a mess now. ---
			if (increaseProductQuantityForThisProjectAPIResponse.data.did_we_create_non_stock_product) {
				if (image_file.name !== undefined) {
					let apiUrl = props.APIUrl + "/products/upload-non-stock-file";

					let formData = new FormData();
					formData.append("non_stock_file", image_file);

					let options = {
						method: "POST",
						body: formData,
						headers: {
							Accept: "application/json"
						}
					};
					fetch(apiUrl, options);
				}

				if (spec_file.name !== undefined) {
					let apiUrl = props.APIUrl + "/products/upload-non-stock-file";

					let formData = new FormData();
					formData.append("non_stock_file", spec_file);

					let options = {
						method: "POST",
						body: formData,
						headers: {
							Accept: "application/json"
						}
					};
					fetch(apiUrl, options);
				}

				if(!!uploads.image) {
					await uploadFiles("image", increaseProductQuantityForThisProjectAPIResponse.data.did_we_create_non_stock_product);
				}
				if(!!uploads.spec) {
					await uploadFiles("spec", increaseProductQuantityForThisProjectAPIResponse.data.did_we_create_non_stock_product);
				}

				await props.reload();

				let dialog_content = (
					<Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
						<DialogTitle id="form-dialog-title set-price-dialog-header">
							{translator("Misc", "success_label")}{" "}
						</DialogTitle>
						<DialogContent>
							{increaseProductQuantityForThisProjectAPIResponse.data.message}
						</DialogContent>
						<DialogActions>
							<Button
								onClick={() => {
									setDialog(null);
									handleClose();
								}}
								color="primary"
							>
								<Translated section="Misc" label="ok_btn" />
							</Button>
						</DialogActions>
					</Dialog>
				);

				setDialog(dialog_content);
			} else {
				// ---- This means there was an error message ----
				let dialog_content = (
					<Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
						<DialogTitle id="form-dialog-title set-price-dialog-header">
							{translator("Misc", "success_label")}
						</DialogTitle>
						<DialogContent>
							{increaseProductQuantityForThisProjectAPIResponse.data.error}
						</DialogContent>
						<DialogActions>
							<Button
								onClick={() => {
									setDialog(null);
									handleClose();
								}}
								color="primary"
							>
								<Translated section="Misc" label="ok_btn" />
							</Button>
						</DialogActions>
					</Dialog>
				);

				setDialog(dialog_content);
			}
			// Reset current nonstock info
			setRequiredProductInformationToUpdateItsQuantityFinalized([]);
			setTitle("");
			setModel("");
			setSupplier("");
			setValidSupplier(null);
			setItemGroup("");
			setValidItemGroup(null);
			setItemCost("");
			setPurchasePrice("");
			setPrice("");
			set_uploads({image: "", spec: ""});
		} else {
			setDialog(null);

			toast.error(
				"Please make sure to fill in non stock title, model number, price item cost and purchase price.",
				{
					position: "bottom-center",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true
				}
			);
		}
	}

	// WE NEED TO PASS THE NON STOCK TITLE, MODEL AND PRICE. THIS IS THE FUNCTION THAT IS RESPONSIBLE FOR IT. WE PASS THIS OBECT THAT CONTAINS IT.
	// MODIFY THIS FUNCTION THAT YOU COPIED AND PASTED FROM THE PRODUCT CARD DIALOG FUNCTIONAL COMPONENT. THIS IS WHERE YOU LEFT OFF.

	// this function gets called in the child component which is the quantity input field for a room. IncreasedAmount is event.target.value and roomName is roomName
	async function pushProductQuantityToTheListOfUpdateProductsQuantityToUpdateInTheBackEnd(
		increasedAmount,
		roomName
	) {
		let requiredProductInformationToUpdateItsQuantity;

		// This variable will be used to check if the room already exist in the user shopping cart and it will do nothing. Don't worry the item quantity
		// will increase because we are going to use this in a for loop. Just in that iteration we don't want it to add another object that contains the product information
		// required to update it's quantity when it already exist in the array.
		let arrayOfValuesToCheckIfItemAlreadyExistInCart = [];

		requiredProductInformationToUpdateItsQuantityFinalized.forEach(
			requiredProductInformationToUpdateItsQuantity => {
				let objectValues = Object.values(requiredProductInformationToUpdateItsQuantity);
				arrayOfValuesToCheckIfItemAlreadyExistInCart = [
					...arrayOfValuesToCheckIfItemAlreadyExistInCart,
					...objectValues
				];
			}
		);

		// If it's the first product for a room. we are doing this because the for loop will not loop because it has a .length of 0.
		if (requiredProductInformationToUpdateItsQuantityFinalized.length === 0) {
			requiredProductInformationToUpdateItsQuantity = requiredProductInformationToUpdateItsQuantityFinalized.concat(
				{
					quantity: increasedAmount,
					roomName: roomName,
				}
			);
		} else {
			for (
				let i = 0;
				i < requiredProductInformationToUpdateItsQuantityFinalized.length;

			) {
				if (
					requiredProductInformationToUpdateItsQuantityFinalized[i].roomName ===
					roomName
				) {
					requiredProductInformationToUpdateItsQuantityFinalized[
						i
					].quantity = increasedAmount;
				} else {
					if (arrayOfValuesToCheckIfItemAlreadyExistInCart.includes(roomName)) {
						//dont use room name use room id instead its better
						// do nothing
					} else {
						requiredProductInformationToUpdateItsQuantity = requiredProductInformationToUpdateItsQuantityFinalized.concat(
							{
								quantity: increasedAmount,
								roomName: roomName,
							}
						);
					}
				}
				i++;
			}
		}

		if (!requiredProductInformationToUpdateItsQuantity) {
			requiredProductInformationToUpdateItsQuantity = [
				...requiredProductInformationToUpdateItsQuantityFinalized
			];
		}

		setRequiredProductInformationToUpdateItsQuantityFinalized(
			requiredProductInformationToUpdateItsQuantity
		);
	}

	return (
		<div>
			{dialog}
			<Button variant="outlined" color="primary" onClick={handleClickOpen}>
				<Translated section="Product Shopping" label="non_stock_btn" />
			</Button>
			<Dialog
				scroll={"body"}
				fullWidth={true}
				maxWidth={"md"}
				open={open}
				onClose={handleClose}
				aria-labelledby="form-dialog-title"
			>
				<DialogTitle id="form-dialog-title set-price-dialog-header">
					<Translated section="Product Shopping" label="non_stock_btn" />{" "}
					<Button id="set-price-close-button" onClick={handleClose} color="primary">
						<i class="fa fa-window-close fa-2x" aria-hidden="true" />
					</Button>
				</DialogTitle>
				<DialogContent>
					<div style={{ marginTop: "3em" }} class="form-group">
						<div class="two-column-group">
						<div class="form-group project-copy-form-group">
							<label>
								<Translated section="Quote Document" label="description_heading" />
							</label>
							<input
								type="text"
								class="form-control  project-copy-input"
								maxLength={48}
								onInput={event => setTitle(event.target.value)}
							/>
						</div>
						<div class="form-group project-copy-form-group">
							<label>
								<Translated section="Quote Document" label="model_heading" />
							</label>
							<input
								type="text"
								class="form-control  project-copy-input"
								onInput={event => setModel(event.target.value)}
							/>
						</div>
						<div class="form-group project-copy-form-group">
							<label>
								<Translated section="Quote Document" label="supplier_heading" />
							</label>
							<Dropdown
								placeholder={translator("Quote Document", "supplier_heading")}
								fluid
								search
								selection
								options={supplierOptions}
								value={supplier}
								onSearchChange={(e, { searchQuery }) => {
									if (supplierTimeout.current) clearTimeout(supplierTimeout.current);
									supplierTimeout.current = setTimeout(() => {
										fetchSupplierSuggestions(searchQuery);
									}, 300);
								}}
								onChange={(e, { value }) => {
									setSupplier(value);
									setValidSupplier(null);
									setItemGroup('');
									setItemGroupOptions([]);
									setValidItemGroup(null);

									if (supplierTimeout.current) clearTimeout(supplierTimeout.current);
									supplierTimeout.current = setTimeout(async () => {
										if (value === "") {
											setValidSupplier(null);
											return;
										}
										try {
											const isValid = await api.post("/products/validate-supplier", { supplier: value });
											setValidSupplier(!!isValid);
											if (isValid) {
												fetchItemGroupSuggestions('', value);
											}
										} catch (e) {
											setValidSupplier(false);
										}
									}, 500);
								}}
								loading={supplierLoading}
								className={"form-control project-copy-input " + (validSupplier === true ? "validation-success" : validSupplier === false ? "validation-error" : "")}
							/>
							{validSupplier === false ? <div className="validation-message">Invalid supplier</div> : null}
						</div>
						<div class="form-group project-copy-form-group">
							<label>
								<Translated section="Quote Document" label="net_price" />
							</label>
							<input
								type="number"
								class="form-control  project-copy-input"
								onInput={event => setPrice(event.target.value.replace("-", ""))}
								onBlur={() => (price === "" ? setPrice("0") : null)}
							/>
						</div>
						<div class="form-group project-copy-form-group">
							<label>
								<Translated section="Quote Document" label="item_cost_heading" />
							</label>
							<input
								type="number"
								class="form-control  project-copy-input"
								onInput={event => setItemCost(event.target.value.replace("-", ""))}
								onBlur={() => (itemCost === "" ? setItemCost("0") : null)}
							/>
						</div>
						<div class="form-group project-copy-form-group">
							<label>
								<Translated section="Quote Document" label="purchase_price_heading" />
							</label>
							<input
								type="number"
								class="form-control  project-copy-input"
								onInput={event => setPurchasePrice(event.target.value.replace("-", ""))}
								onBlur={() => (purchasePrice === "" ? setPurchasePrice("0") : null)}
							/>
						</div>
						<div class="form-group project-copy-form-group">
							<label>
								<Translated section="Quote Document" label="item_group_heading" />
							</label>
							<Dropdown
								placeholder={translator("Quote Document", "item_group_heading")}
								fluid
								search
								selection
								disabled={!supplier}
								options={itemGroupOptions}
								value={itemGroup || ''}
								onSearchChange={(e, { searchQuery }) => {
									if (itemGroupTimeout.current) clearTimeout(itemGroupTimeout.current);
									itemGroupTimeout.current = setTimeout(() => {
										fetchItemGroupSuggestions(searchQuery, supplier);
									}, 300);
								}}
								onChange={(e, { value }) => {
									setItemGroup(String(value));
									setValidItemGroup(null);
									if (itemGroupTimeout.current) clearTimeout(itemGroupTimeout.current);
									itemGroupTimeout.current = setTimeout(async () => {
										if (value === "") {
											setValidItemGroup(null);
											return;
										}
										try {
											const isValid = await api.post("/products/validate-item-group", { itemGroup: value });
											setValidItemGroup(!!isValid);
										} catch (e) {
											setValidItemGroup(false);
										}
									}, 500);
								}}
								loading={itemGroupLoading}
								className={"form-control project-copy-input " + (validItemGroup === true ? "validation-success" : validItemGroup === false ? "validation-error" : "")}
							/>
							{validItemGroup === false ? <div className="validation-message">Invalid item group</div> : null}
						</div>
						</div>
						
						<AddNSuploader update={update_uploads} />

						<h6>{translator("Product Shopping", "available_rooms")}</h6>
						{props.roomIds
							? props.roomIds.map((roomId, index) => (
									<RoomCheckBox // btw the name for it was wrong. it should be RoomInputBox. Will change it later in the future because right now I have to finish this before september
										key={index}
										roomId={roomId}
										roomName={props.roomNames[index]}
										setQuantityStateFromChildComponent={
											pushProductQuantityToTheListOfUpdateProductsQuantityToUpdateInTheBackEnd
										} //this is how you change the state of a parent component from a child component
										projectId={props.projectId}
									/>
							  ))
							: null
						}

						<DialogActions>
							<Button onClick={saveNewNonStock} color="primary">
								<Translated section="Misc" label="confirm_btn" />
							</Button>
							<Button onClick={handleClose} color="primary">
								<Translated section="Misc" label="close_btn" />
							</Button>
						</DialogActions>
					</div>
				</DialogContent>
			</Dialog>
		</div>
	);
}

const mapStateToProps = state => ({
	APIUrl: state.APIUrl,
	selected_language: state.selected_language
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(AddNonStockDialog);
